var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallRate1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15z",
    fill: "#B91C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.567 11.629c0 1.294-.735 2.344-1.64 2.344-.907 0-1.641-1.05-1.641-2.344 0-1.294.734-2.344 1.64-2.344.906 0 1.64 1.05 1.64 2.344zM21.004 11.629c0 1.294-.734 2.344-1.64 2.344-.906 0-1.64-1.05-1.64-2.344 0-1.294.734-2.344 1.64-2.344.906 0 1.64 1.05 1.64 2.344zM21.094 22.734c0-.584-.158-1.164-.464-1.704a4.658 4.658 0 00-1.321-1.445 6.585 6.585 0 00-1.977-.965A8.08 8.08 0 0015 18.281c-.8 0-1.593.115-2.332.34a6.585 6.585 0 00-1.977.965 4.658 4.658 0 00-1.32 1.444 3.442 3.442 0 00-.465 1.704h12.188z",
    fill: "#111827"
  })));
}
export default SvgSmallRate1;